if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if(this.id == 'digital-giftcard-2024-form') {
        this.querySelector(`[name="properties[To]"]`).value = `${this.querySelector(`[name="properties[_recipient_first_name]"]`).value} ${this.querySelector(`[name="properties[_recipient_last_name]"]`).value}`

        if(this.querySelector(`[name="properties[_recipient_email_address]"]`).value == '') {
          this.querySelector(`[name="properties[Deliver to]"]`).setAttribute("disabled", true)
        } else {
          this.querySelector(`[name="properties[Deliver to]"]`).removeAttribute("disabled")
          this.querySelector(`[name="properties[Deliver to]"]`).value = this.querySelector(`[name="properties[_recipient_email_address]"]`).value
        }


        let set_type = this.querySelector(`[name="properties[_send_type]"]:checked`).value;
        // fixed 062525 - if delivery type is set to 'email', need to verify email addresses.
        if(
          (
            set_type == "Email" && 
            (this.querySelector(`[name="properties[_recipient_email_address_verify]"]`).value == '' || this.querySelector(`[name="properties[_recipient_email_address_verify]"]`).value.trim() != this.querySelector(`[name="properties[_recipient_email_address]"]`).value.trim())
          ) 
        ) {
          console.log("not verified");
          document.documentElement.scrollTop = 600;
          this.querySelector(`[name="properties[_recipient_email_address_verify]"]`).style.borderColor = 'red';
          this.querySelector(`[name="properties[_recipient_email_address]"]`).style.borderColor = 'red';
          this.querySelector('.unmatchingEmailsErr').style.display = 'block';
          return false;
        } else {
          this.querySelector(`[name="properties[_recipient_email_address_verify]"]`).style.borderColor = 'black';
          this.querySelector(`[name="properties[_recipient_email_address]"]`).style.borderColor = 'black';
          this.querySelector('.unmatchingEmailsErr').style.display = 'none';
          console.log('email verified')
        }


        this.querySelector(`[name="properties[Greeting]"]`).value = this.querySelector(`[name="properties[_greeting]"]`).value != '' ? `${this.querySelector(`[name="properties[_greeting]"]`).value.split(" ").splice(0,5).join(" ")}...` : ''

        let dateFieldValue = this.querySelector(`[name="properties[_delivery_date]"]`).value.replaceAll('-','/')
        let formatDeliveryDate = new Date(dateFieldValue).toDateString().split(" ").splice(1,3)

        this.querySelector(`[name="properties[Deliver on]"]`).value = `${formatDeliveryDate[0]} ${formatDeliveryDate[1]}, ${formatDeliveryDate[2]}`
      }
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          document.dispatchEvent(new CustomEvent('addToCart'))          
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.addGiftWithPurchase();
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }


    addGiftWithPurchase() {
      let gwp = !!this.querySelector("input[name='gift_with_product']");
      let gwp2 = !!this.querySelector("input[name='gift_with_product2']");
      let gwp3 = !!this.querySelector("input[name='gift_with_product3']");

  
      if (gwp || gwp2 || gwp3 ) {
        let gift_id;
        let gift_id2;
        let gift_id3;

        let gift_threshold;
        let gift_threshold2;
        let gift_threshold3;

        if(gwp) {
          gift_id = Number(this.querySelector("input[name='gift_with_product']").dataset.id);
          gift_threshold = Number(this.querySelector("input[name='gift_with_product']").dataset.threshold)*100;
        }
        if(gwp2) {
          gift_id2 = Number(this.querySelector("input[name='gift_with_product2']").dataset.id);
          gift_threshold2 = Number(this.querySelector("input[name='gift_with_product2']").dataset.threshold)*100;
        }
        if(gwp3) {
          gift_id3 = Number(this.querySelector("input[name='gift_with_product3']").dataset.id);
          gift_threshold3 = Number(this.querySelector("input[name='gift_with_product3']").dataset.threshold)*100;
        }

        $.ajax({
          type: 'GET',
          url: '/cart.js',
          cache: false, 
          dataType: 'json',
          success: function(cart) {
            let accumulativeGwpPrice = 0;
            let accumulativeGwpPrice2 = 0;
            let accumulativeGwpPrice3 = 0;

            let giftPresent = false;
            let giftPresent2 = false;
            let giftPresent3 = false;


            cart.items.forEach(function (arrayItem) {
              if(arrayItem.properties['_gwp_eligible'] == 'true') {
                accumulativeGwpPrice = accumulativeGwpPrice + (arrayItem.price*arrayItem.quantity)
              }
              if(arrayItem.properties['_gwp_eligible2'] == 'true') {
                accumulativeGwpPrice2 = accumulativeGwpPrice2 + (arrayItem.price*arrayItem.quantity)
              }
              if(arrayItem.properties['_gwp_eligible3'] == 'true') {
                accumulativeGwpPrice3 = accumulativeGwpPrice3 + (arrayItem.price*arrayItem.quantity)
              }

              if(!!gift_id && gift_id == arrayItem.variant_id) {
                giftPresent = true
              }
              if(!!gift_id2 && gift_id2 == arrayItem.variant_id) {
                giftPresent2 = true
              }
              if(!!gift_id3 && gift_id3 == arrayItem.variant_id) {
                giftPresent3 = true
              }
            });
           
            // if((accumulativeGwpPrice >= gift_threshold && !giftPresent) && (accumulativeGwpPrice2 >= gift_threshold2 && !giftPresent2) && (accumulativeGwpPrice3 >= gift_threshold3 && !giftPresent3)) {
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { items: [{"id": gift_id,"quantity": 1, "properties[_gwp_gift]" : 1}, {"id": gift_id2,"quantity": 1, "properties[_gwp_gift2]" : 1}, {"id": gift_id3,"quantity": 1, "properties[_gwp_gift3]" : 1}]},
            //     dataType: 'json',
            //     success: function() { console.log('added') } 
            //   });
            // } else if((accumulativeGwpPrice >= gift_threshold && !giftPresent) && (accumulativeGwpPrice2 >= gift_threshold2 && !giftPresent2)) {
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { items: [{"id": gift_id,"quantity": 1, "properties[_gwp_gift]" : 1}, {"id": gift_id2,"quantity": 1, "properties[_gwp_gift2]" : 1}]},
            //     dataType: 'json',
            //     success: function() { console.log('added') } 
            //   });
            // } else if((accumulativeGwpPrice3 >= gift_threshold3 && !giftPresent3) && (accumulativeGwpPrice2 >= gift_threshold2 && !giftPresent2)) {
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { items: [{"id": gift_id2,"quantity": 1, "properties[_gwp_gift2]" : 1}, {"id": gift_id3,"quantity": 1, "properties[_gwp_gift3]" : 1}]},
            //     dataType: 'json',
            //     success: function() { console.log('added') } 
            //   });
            // } else if((accumulativeGwpPrice3 >= gift_threshold3 && !giftPresent3) && (accumulativeGwpPrice >= gift_threshold && !giftPresent)) {
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { items: [{"id": gift_id,"quantity": 1, "properties[_gwp_gift]" : 1}, {"id": gift_id3,"quantity": 1, "properties[_gwp_gift3]" : 1}]},
            //     dataType: 'json',
            //     success: function() { console.log('added') } 
            //   });
            // } else if(accumulativeGwpPrice >= gift_threshold && !giftPresent) {
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { "id": gift_id,"quantity": 1, "properties[_gwp_gift]" : 1 },
            //     dataType: 'json',
            //     success: function() { console.log('added') } 
            //   });
            // } else if (accumulativeGwpPrice2 >= gift_threshold2 && !giftPresent2) {
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { "id": gift_id2,"quantity": 1, "properties[_gwp_gift2]" : 1 },
            //     dataType: 'json',
            //     success: function() { console.log('added') } 
            //   });
            // } else if (accumulativeGwpPrice3 >= gift_threshold3 && !giftPresent3) {
            //   $.ajax({
            //     type: 'POST',
            //     url: '/cart/add.js',
            //     data: { "id": gift_id3,"quantity": 1, "properties[_gwp_gift3]" : 1 },
            //     dataType: 'json',
            //     success: function() { console.log('added') } 
            //   });
            // }
          }
        });
      } 
    }


    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
